import { Button, styled } from "@mui/material";
import { menuButtonSx } from "./navbar.styles";

const NavigationButton = styled(Button)({
	...menuButtonSx,
});

export default NavigationButton;
